<template>
  <div style="height: 100%; overflow-y: auto !important;">
    <template v-if="!loading">
      <template>
        <no-items
          v-if="items.length <= 0"
          :title="'계약정보가 없습니다' | translate"
        />
        <contract-list-item
          :items="items"
          @click:contract="onClickContract"
        />
      </template>
    </template>
    <template v-else>
      <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
        <progress-loading />
      </div>
    </template>
  </div>
</template>

<script>
import {PATH} from "@/constants";
import NoItems from "@/components/items/NoItems";
import ContractListItem from "@/components/items/contract/ContractListItem";
import Contract from "@/model/contract";
import VuexProps from "@/framework/vuex/VuexProps";
import ProgressLoading from "@/components/part/ProgressLoading";
import Permissions from "@/constants/permissions";

export default {
  name: "ContractTabsItems",
  components: {ProgressLoading, ContractListItem, NoItems},
  mixins: [VuexProps],
  props: {
    accountId: {
      type: [Number, String],
      default: undefined,
    },
    changeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
    }
  },
  watch: {
    accountId: {
      immediate: true,
      handler() {
        this.loadContractList();
      },
    },
  },
  methods: {
    async loadContractList(loading = true) {
      if (!this.accountId) return;
      if (this.loading) return;
      this.loading = loading;
      try {
        const response = await this.$request(PATH.CONTRACT.LIST)
          .setObject({accountId: this.accountId})
          .wait(500)
          .enqueue();
        this.items = response.data.map(item => new Contract(item));
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },

    /**
     * 계약을 클릭하였습니다. 상세페이지로 이동합니다.
     */
    onClickContract(item) {
      this.backGuard.pop();
      const params = {
        contractId: !item ? 0 : item.raw.contractId,
        contractNo: !item ? 0 : item.raw.contractNo,
        accountId: !item ? this.accountId : item.raw.accountId,
        permission: Permissions.EXPOSE_ACCOUNT_INFO
      }
      this.routerManager.push({
        name: "ContractRegister",
        params
      });
    },
  },
}
</script>

<style scoped>

</style>